(function () {
  'use strict';

  function getItems(modal) {
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return [];
    return Array.from(content.children).filter(function (el) {
      return (
        el.tagName === 'IMG' ||
        el.tagName === 'DEFERRED-MEDIA' ||
        el.tagName === 'MODEL-VIEWER' ||
        el.tagName === 'PRODUCT-MODEL' ||
        el.classList.contains('global-media-settings')
      );
    });
  }

  function pauseAllMedia(modal) {
    modal.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    });
    modal.querySelectorAll('iframe').forEach(function (f) {
      try { f.src = f.src; } catch (e) {}
    });
    modal.querySelectorAll('deferred-media').forEach(function (dm) {
  const video = dm.querySelector('video, iframe');
  if (video && dm.querySelector('template')) {
    video.remove();
    dm.removeAttribute('loaded');
  }
});
  }
  
function showIndex(modal, index) {
  const items = getItems(modal);
  if (!items.length) return;
  const n = items.length;
  const safe = ((index % n) + n) % n;
  pauseAllMedia(modal);
  items.forEach(function (item, i) {
    item.classList.toggle('is-active', i === safe);
  });
  const sliderId = modal.dataset.sliderId;
  document.querySelectorAll('.product-media-modal__dots[data-slider-id="' + sliderId + '"] span').forEach(function (dot, i) {
    dot.classList.toggle('is-active', i === safe);
  });
  modal.dataset.currentIndex = String(safe);

  // Auto-play video khi lướt tới deferred-media
  const active = items[safe];
  if (active && active.tagName === 'DEFERRED-MEDIA') {
    requestAnimationFrame(function () {
      if (typeof active.loadContent === 'function') {
        try {
          active.loadContent(false);
          const video = active.querySelector('video');
          if (video) {
            video.muted = true; // đảm bảo muted để browser cho autoplay
            video.play().catch(function () {});
          }
        } catch (e) {}
      }
    });
  }
}

  function makeBtn(cls, label, svgPath) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'product-media-modal__nav ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      svgPath + '</svg>';
    return b;
  }

  function initSlider(modal) {
    if (modal.dataset.sliderInit === 'true') return;
    const items = getItems(modal);
    if (items.length === 0) return;
    modal.dataset.sliderInit = 'true';

    const sliderId = 'slider-' + Math.random().toString(36).slice(2, 9);
    modal.dataset.sliderId = sliderId;

    let startIndex = items.findIndex(function (i) {
      return i.classList.contains('active');
    });
    if (startIndex < 0) startIndex = 0;

    if (items.length <= 1) {
      showIndex(modal, startIndex);
      return;
    }

    function nav(dir) {
      const cur = parseInt(modal.dataset.currentIndex || '0', 10);
      showIndex(modal, cur + dir);
    }

    const prevBtn = makeBtn('product-media-modal__nav--prev', 'Previous', '<polyline points="15 18 9 12 15 6"></polyline>');
    const nextBtn = makeBtn('product-media-modal__nav--next', 'Next', '<polyline points="9 18 15 12 9 6"></polyline>');
    prevBtn.dataset.sliderId = sliderId;
    nextBtn.dataset.sliderId = sliderId;

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      nav(-1);
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      nav(1);
    });

    // ✅ Append vào BODY — không phải modal — để event không bao giờ đến modal
    document.body.appendChild(prevBtn);
    document.body.appendChild(nextBtn);

    // Dots
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'product-media-modal__dots';
    dotsWrap.dataset.sliderId = sliderId;
    items.forEach(function (_, i) {
      const dot = document.createElement('span');
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        showIndex(modal, i);
      });
      dotsWrap.appendChild(dot);
    });
    document.body.appendChild(dotsWrap);

    // Show/hide nav theo trạng thái modal
    function setNavVisible(visible) {
      prevBtn.classList.toggle('is-visible', visible);
      nextBtn.classList.toggle('is-visible', visible);
      dotsWrap.classList.toggle('is-visible', visible);
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open') {
          const isOpen = modal.hasAttribute('open');
          setNavVisible(isOpen);
          if (!isOpen) pauseAllMedia(modal);
        }
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    // Set initial state
    setNavVisible(modal.hasAttribute('open'));
    showIndex(modal, startIndex);

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); nav(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); nav(1); }
    });

    // Touch swipe trên modal
    let touchStartX = 0;
    modal.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) nav(diff > 0 ? -1 : 1);
    }, { passive: true });
  }

  function syncToOpener(modal, mediaId) {
    if (!mediaId) return;
    const items = getItems(modal);
    const idx = items.findIndex(function (it) {
      const id = it.dataset.mediaId || it.getAttribute('data-media-id');
      return id === String(mediaId);
    });
    if (idx >= 0) showIndex(modal, idx);
  }

  function init() {
    document.querySelectorAll('product-modal').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

 document.addEventListener('click', function (e) {
    if (e.target.closest('product-modal')) return;
    if (e.target.closest('.product-media-modal__nav')) return;
    if (e.target.closest('.product-media-modal__dots')) return;
    const opener = e.target.closest('[data-media-id]');
    if (!opener) return;
    setTimeout(function () {
      const modal = document.querySelector('product-modal[open]');
      if (!modal) return;
      initSlider(modal);
      syncToOpener(modal, opener.dataset.mediaId || opener.getAttribute('data-media-id'));
    }, 50);
  });

  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();